import React from "react";
import { makeStyles } from "@mui/styles";
import { Paper } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const TableOfContents = ({
  focus,
  setFocus,
  headings,
  messageList,
  isMobile,
  windowHeight,
}) => {
  const classes = useStyles({ windowHeight });
  const { t } = useTranslation();

  const renderToc = (item) => {
    return (
      <div
        className={clsx([classes.tocHeading, classes[item.messageType]])}
        key={item.id}
      >
        <ChevronRightIcon />
        <a className={classes.tocLink} onClick={() => scrollToMessage(item.id)}>
          {item.message}
        </a>
      </div>
    );
  };

  const scrollToMessage = (messageId) => {
    setFocus("chat");
    const doScroll = () => {
      const messageItem = document.getElementById(messageId);
      const messagePosition =
        messageItem.offsetTop - messageList.current.offsetTop;
      messageList.current.scrollTo({
        top: messagePosition,
        behaviour: "smooth",
      });
    };
    if (focus !== "chat" && isMobile) setTimeout(doScroll, 200);
    else doScroll();
  };

  return (
    <Paper
      className={clsx(classes.toc, {
        [classes.tocFocus]: focus === "toc",
      })}
    >
      <div className={classes.cardTitle}>{t("party.toc")}</div>
      <div className={classes.cardContent}>{headings.map(renderToc)}</div>
    </Paper>
  );
};

const useStyles = makeStyles((theme) => ({
  tocHeading: {
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    paddingLeft: 15,
  },
  heading: {
    maxWidth: "calc(100% - 15px)",
    fontWeight: "bold",
    fontSize: "1.3em",
  },
  heading2: {
    maxWidth: "calc(100% - 30px)",
    marginLeft: 15,
    fontWeight: "bold",
    fontSize: "1.1em",
  },
  heading3: {
    maxWidth: "calc(100% - 45px)",
    marginLeft: 30,
    fontWeight: "500",
    fontSize: "1em",
  },
  tocLink: {
    flex: 1,
    textDecoration: "none",
    color: theme.palette.text.primary,
    paddingTop: 12,
    paddingBottom: 9,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: "1.2em",
    fontFamily: "Roboto, sans-serif",
  },
  toc: {
    display: "none",
    paddingTop: 0,
    borderRadius: 0,
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "column",
      borderRadius: 4,
      flex: 1,
      margin: 10,
      marginBottom: 20,
      maxHeight: (props) => props.windowHeight / 2 - 85,
    },
  },
  tocFocus: {
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
      height: (props) => props.windowHeight - 153,
    },
  },
  cardTitle: {
    height: 50,
    paddingLeft: 20,
    display: "none",
    fontWeight: "bold",
    fontFamily: "Roboto, sans-serif",
    borderBottom: "1px solid #D8D8D8",
    justifyContent: "flex-start",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  cardContent: {
    flex: 1,
    overflow: "auto",
  },
}));

export default TableOfContents;
